import {Component, Input, OnInit} from '@angular/core';
import {ModalService} from '../../core/services/modal/modal.service';

@Component({
    selector: 'app-modal-processing',
    templateUrl: './modal-processing.component.html',
    styleUrls: ['./modal-processing.component.scss'],
    standalone: false
})
export class ModalProcessingComponent implements OnInit {

  @Input() idModal: string;
  @Input() textDescription: string;
  @Input() title: string;
  constructor(private _MODAL: ModalService) { }

  ngOnInit() {
  }

  close() {
    this._MODAL.closeModal(this.idModal);
  }
}
